export const getTableAndFigureContent = (root, sectionId) => {
  const ditatitle = root.querySelector(`#${sectionId}`);
  if (!ditatitle) return null;
  let content = findFigureContent(ditatitle);

  if (!content) {
    content = findTableContent(ditatitle);
  }

  return content;
}

// To walk thru DOM to find any images under fig element
// and combine them into a string to be displayed as modal box content
const findFigureContent = (ditatitle) => {
  const fig = ditatitle.closest("fig");
  if (!fig) return null;

  const images = fig.querySelectorAll("img, svg");
  return Array.from(images).map(img => img.outerHTML).join("\n");
}

// To walk thru DOM to find the first table found under ditatitle
const findTableContent = (ditatitle) => {
  let current = ditatitle.parentNode?.nextElementSibling;

  while (current) {
    if (current.tagName.toLowerCase() === "table") {
      return current.outerHTML;
    }

    const tableInWrapper = current.querySelector("table");
    if (tableInWrapper) {
      return tableInWrapper.outerHTML;
    }

    current = current.nextElementSibling;
  }
  return null;
}